import React from 'react';
import Tab from 'olive-react-myoneui/lib/Tab';
import Accordion from 'olive-react-myoneui/lib/Accordion';
import CoursePlaySlot from './CoursePlaySlot';

function CourseCurriculum({ coursedetails, courseInfo = 0 }) {
  const lecturefn = (args,args2 = "") => {
    const filter = coursedetails?.course.lectures.filter(
      (item) => item.cl_section_id === args
    );
    if(args2 == "count"){
      return filter.length
    }
    let accordianBody = filter.map((details, key) => (
      <CoursePlaySlot
        className="course-details mb-3"
        courseTitle={details.cl_lecture_name}
        courseTime={details.duration_hm}
        preview={details.cl_lecture_preview}
        lectureType={details.cl_lecture_type}
        lectureName={details.cl_filename}
        videoId={details.id}
      />
    ));
    return accordianBody;
  };


  let totalSectionlength = coursedetails?.course.sections.length - 1;
  let accordian = coursedetails?.course.sections.map((details, i) => (
    <Accordion.Item
      eventKey={`${i}`}
      className={totalSectionlength === i ? '' : 'mb-3'}
    >
      <Accordion.Header>
        <span className="sec-heading">{details.s_name}</span>
        <span className="course-short-info">
          {lecturefn(details.id,"count")} {lecturefn(details.id,"count") > 1 ? "Lectures" : "Lecture"} 
        </span>
      </Accordion.Header>
      <Accordion.Body>
        {lecturefn(details.id)}
        {/* <CoursePlaySlot className="course-details mb-3" courseTitle="Random Module - Shuffle and Choice" courseTime="04:08" />
              <CoursePlaySlot className="course-details mb-2" courseTitle="Up and Down Functions" courseTime="05:36" /> */}
      </Accordion.Body>
    </Accordion.Item>
  ));

  return (
    <Tab.Pane eventKey="curriculum">
      <div
        className={
          courseInfo == 0
            ? `tab-course-contents curriculum px-0 pt-0 pb-4`
            : `tab-course-contents curriculum px-0 pt-0`
        }
      >
        {courseInfo == 0 ? (
          <span className="course-short-info d-flex mb-2">
            {coursedetails?.course.sections.length} {coursedetails?.course.sections.length > 1 ? "Sections" : "Section"} •{' '}
            {coursedetails?.course.lecture_count} {coursedetails?.course.lecture_count > 1 ? "Lectures" : "Lecture"}{' '}
            {/* {coursedetails?.course.cb_total_video_hours} total length */}
          </span>
        ) : (
          ''
        )}
        <Accordion defaultActiveKey="0">
          {accordian}
        </Accordion>
      </div>
    </Tab.Pane>
  );
}

export default CourseCurriculum;
